import { Cell } from "./Cell";
import { ICell, ICellConfig, ILayout, ILayoutConfig, LayoutEvents } from "./types";
import { create } from "@dhx/ts-common/dom";

export class Layout extends Cell implements ILayout {
	public config: ILayoutConfig;
	protected _all;
	protected _cells: ICell[];					// cells

	private _xLayout: boolean;					// vertical or horizontal layout
	private _root: ILayout;

	private _isViewLayout: boolean;

	constructor(parent: any, config: ILayoutConfig) {
		super(parent, config);
		// root layout
		this._root = this.config.parent || this;
		this._all = {};
		this._parseConfig();

		if ((this.config as ILayoutConfig).views) {
			this.config.activeView = this.config.activeView || this._cells[0].id;
			this._isViewLayout = true;
		}
		if (!config.parent) {
			const view = create({ render: () => this.toVDOM() }, this);
			this.mount(parent, view);
		}
	}
	toVDOM() {
		if (this._isViewLayout) {
			const roots = [this.getCell(this.config.activeView).toVDOM()];
			return super.toVDOM(roots);
		}
		let nodes = [];
		this._cells.forEach(cell => {
			const node = cell.toVDOM();
			if (Array.isArray(node)) {
				nodes = nodes.concat(node);
			} else {
				nodes.push(node);
			}
		});
		return super.toVDOM(nodes);
	}
	removeCell(id: string) {
		if (!this.events.fire(LayoutEvents.beforeRemove, [id])) {
			return;
		}
		const root = (this.config.parent || this);
		if (root !== this) { return root.removeCell(id); }
		// this === root layout
		const view = this.getCell(id);
		if (view) {
			const parent = view.getParent();
			delete this._all[id];
			parent._cells = parent._cells.filter((cell: ICell) => cell.id !== id);
			parent.paint();
		}
		this.events.fire(LayoutEvents.afterRemove, [id]);
	}
	addCell(config: ICellConfig, index: number = -1) {
		if (!this.events.fire(LayoutEvents.beforeAdd, [config.id])) {
			return;
		}
		const view = this._createCell(config);
		if (index < 0) {
			index = this._cells.length + index + 1;
		}
		this._cells.splice(index, 0, view);
		this.paint();
		if (!this.events.fire(LayoutEvents.afterAdd, [config.id])) {
			return;
		}
	}
	getId(index: number) {
		if (index < 0) {
			index = this._cells.length + index;
		}
		return this._cells[index] ? this._cells[index].id : undefined;
	}
	getRefs(name: string) {
		return this._root.getRootView().refs[name];
	}
	getCell(id: string) {
		return (this._root as any)._all[id];
	}
	// TODO: remove sute_7.0
	cell(id: string) {
		return this.getCell(id);
	}
	protected _getCss(content?: boolean) {
		const layoutCss = this._xLayout ? "dhx_layout-columns" : "dhx_layout-rows";
		const directionCss = this.config.align ? " " + layoutCss + "--" + this.config.align : "";
		if (content) {
			return layoutCss + " dhx_layout-cell" + (this.config.align ? " dhx_layout-cell--" + this.config.align : "");
		} else {
			const cellCss = this.config.parent ? super._getCss() : "dhx_widget dhx_layout";
			const fullModeCss = this.config.parent ? "" : " dhx_layout-cell";
			return cellCss + (this.config.full ? fullModeCss : " " + layoutCss) + directionCss;
		}
	}
	private _parseConfig() {
		const config = this.config;
		const cells = config.rows || config.cols || config.views || [];

		this._xLayout = !config.rows;
		this._cells = cells.map(a => this._createCell(a));
	}
	private _createCell(cell: ILayoutConfig): ICell {
		let view: ICell;
		if (cell.rows || cell.cols || cell.views) {
			cell.parent = this._root;
			view = new Layout(this, cell);
		} else {
			view = new Cell(this, cell);
		}
		// FIxME
		(this._root as any)._all[view.id] = view;
		return view;
	}
}